export function careerPeriod(player, fallback = "") {
  const start = player?.careerStartDate
    ? new Date(player.careerStartDate).getFullYear()
    : "";
  const end = player?.careerEndDate
    ? new Date(player.careerEndDate).getFullYear()
    : "";

  if (start && end) return `${start} – ${end}`;
  if (start) return `${start} – Actualidad`;
  if (end) return `Hasta ${end}`;
  return fallback;
}
